// src/Pages/Messages.js
import "../Styles/CreateUser.css";
import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import UserProfileHeader from "./UserProfileHeader";
import { useNavigate } from "react-router-dom";

export default function Messages() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const API = useMemo(
    () => process.env.REACT_APP_API || process.env.REACT_APP_BACKEND_URL || "",
    []
  );

  const load = () => {
    setLoading(true);
    axios
      .post(`${API}/get_messages`)
      .then(({ data }) => {
        if (data?.success && Array.isArray(data.data)) {
          setMessages(data.data);
        } else {
          setMessages([]);
        }
      })
      .catch(() => setMessages([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
  }, [API]);

  const open = (m) => {
    const t = Number(m?.type);
    const href =
      t === 2
        ? `/assign-yubikey?token=${m.message_link}`
        : `/mda-review?token=${m.message_link}`;
    navigate(href);
  };

  const fmt = (d) => {
    try {
      return d ? new Date(d).toLocaleString() : "-";
    } catch {
      return "-";
    }
  };

  return (
    <div className="dashboard">
      <UserProfileHeader isAdmin={true} />
      <div className="container" style={{ padding: 16 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <h2 style={{ margin: 0 }}>Messages</h2>
          <button onClick={load} disabled={loading} style={{ padding: "6px 10px" }}>
            {loading ? "Loading…" : "Refresh"}
          </button>
        </div>

        {!loading && (!messages || messages.length === 0) && (
          <p style={{ marginTop: 12 }}>No messages.</p>
        )}

        <ul style={{ listStyle: "none", padding: 0, marginTop: 12 }}>
          {(Array.isArray(messages) ? messages : []).map((m) => {
            const t = Number(m?.type);
            const badge =
              t === 2 ? "Logistics · Assign YubiKey" : "MDA Registration";
            return (
              <li
                key={m.id ?? m.message_link}
                onClick={() => open(m)}
                style={{
                  marginBottom: 12,
                  padding: 12,
                  border: "1px solid #eee",
                  borderRadius: 8,
                  cursor: "pointer",
                }}
              >
                <div style={{ fontSize: 12, opacity: 0.7, marginBottom: 6 }}>
                  {badge}
                </div>
                <div>
                  <strong>{m.company_name}</strong> — {m.first_name} {m.last_name} (
                  {m.email})
                </div>
                <div style={{ marginTop: 4, fontSize: 13 }}>
                  <em>Status: {m.status}</em>
                  {m.create && (
                    <span style={{ marginLeft: 8, opacity: 0.75 }}>
                      • Submitted: {fmt(m.create)}
                    </span>
                  )}
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
